export const EXPENSE_FINANCE_TAB_ID = 1
export const EXPENSE_HR_TAB_ID = 2
export const LIST_OF_PROJECT_TAB_ID = 3

export const EXPENSE_CATEGORY_LIST_TABS = [
  {
    id: EXPENSE_FINANCE_TAB_ID,
    title: 'Finance',
    subTitle: 'Expense Categories',
    typeCategories: ['New Category', 'New Category 2', 'Type of Payment'],
    defaultTab: true
  },
  {
    id: EXPENSE_HR_TAB_ID,
    title: 'HR',
    subTitle: 'Assets Categories',
    typeCategories: ['New Category']
  },
  {
    id: LIST_OF_PROJECT_TAB_ID,
    title: 'List of projects',
    subTitle: 'Type of service'
  }
]



// WEBPACK FOOTER //
// ./src/constants/Tabs/expenseListTabs.js